import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@unite-us/app-components';
import { translateStatus, getBadgeColor, getTextColor } from './utils/status';

const StatusBadge = ({ task }) => (
  <Badge
    id={`task-table-badge-${task?.id}`}
    text={translateStatus(task)}
    color={getBadgeColor(task)}
    className="px-3 text-sm capitalize"
    style={{
      color: getTextColor(task),
    }}
  />
);

StatusBadge.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
  }),
};

StatusBadge.defaultProps = {
  task: null,
};

export default StatusBadge;
